import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';

export default function selectorDirective(context=document.body) {
	const $context = $(context);

	$context.find('[sw-selector]').each(function() {
		const $element = $(this);
		const json = $element.attr('sw-selector');
		const settings = directiveSettings(json, {
			selector: '> [sw-toggler]',
		}, 'selector');

		const $togglers = $element.find(settings.selector);
		const togglers = Array.from($togglers).map((el) => $(el).data('toggler'));

		const selectToggler = function(toggler) {
			for (let otherToggler of togglers) {
				if (otherToggler !== toggler) {
					otherToggler.close();
				}
			}
		};

		togglers.forEach((toggler) => toggler.on('open', () => selectToggler(toggler)));
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/selector.js